/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query Products2Query($uid: String!) {
    prismic {
      products2(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_Products2BodyHerobox {
          type
            label
            fields {
              hero_box_text
              hero_box_text_icon
            }
            primary {
              fullscreen
              large_text
              text_color
              hero_background_color
              hero_background_image
              hero_box_cta_text
              hero_box_cta_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              hero_box_title
              hero_box_title_color
              hero_heading
              hero_small_heading
              hero_small_heading_icon
              hero_subheading
              hero_box_cta_scroll_to_element_id
              hero_box_cta_id
              hero_box_cta_position
              hero_box_cta_color
              hero_box_slim
            }
        },
        ... on PRISMIC_Products2BodyHerotext {
          type
            label
            primary {
              fullscreen
              large_text
              text_color
              background_color
              background_image
              display_primary_cta
              display_secondary_cta
              heading
              primary_cta_color
              primary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              primary_cta_text
              secondary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              secondary_cta_text
              subheading
              text_alignment
            }
        },
        ... on PRISMIC_Products2BodyCodeblock {
          type
  label
  primary {
    heading,
    heading_color,
    subheading,
    subheading_color
    background_color
    background_image
    copy
    copy_color
    headline
    headline_color
    code_link_url {
      ... on PRISMIC__ExternalLink {
        _linkType
        url
      }
    }
    code_link_text
    link_text
    text_color
    link_url {
      ... on PRISMIC__ExternalLink {
        _linkType
        url
      }
    }
  }
  fields {
    code_content
    code_language
  }
        },
        ... on PRISMIC_Products2BodyListalternatingv2 {
          type
            label
            fields {
              list_alt_image
              list_alt_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              list_alt_link_text
              list_alt_text
              list_alt_title
              list_link_color
              list_text_color
              list_title_color
            }
            primary {
              background_color
              heading
              subheading
              background_image
              heading_color
              subheading_color
              text_color
            }
        },
        ... on PRISMIC_Products2BodyImagescontentband {
          type
          label
          fields {
            image
          }
          primary {
            background_color
            background_image
            content_link {
              ... on PRISMIC__ExternalLink {
                _linkType
                url
              }
            }
            content_link_color
            content_link_text
            content_text
            content_text_color
            content_title
            content_title_color
            heading
            heading_color
            subheading
            subheading_color
            row_reverse
          }
        },
        ... on PRISMIC_Products2BodyListgridv2 {
          type
            label
            primary {
              background_color
              background_image
              heading
              heading_color
              list_column_number
              list_item_alignment_position
              list_item_heading_color
              list_item_text_color
              list_item_icon_position
              list_item_icon_size
              subheading
              subheading_color
              text_color
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              annotation
            }
            fields {
              list_item_heading
              list_item_icon
              list_item_text
              list_item_url_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              list_item_url_text
            }
        },
        ... on PRISMIC_Products2BodyCarouseltestimonial {
          type
            label
            primary {
              background_color
              background_image
              text_color
              heading
              heading_color
              subheading1
              subheading_color
            }
            fields {
              logo
              quote
              author
              author_details
              avatar
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_text
            }
        },
        ... on PRISMIC_Products2BodyLocations {
          type
            label
            fields {
              location_name
              location_server_name
              location_link_text
              location_link_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
            }
            primary {
              background_color
              background_image
              column_number
              heading_color
              heading
              subheading
              subheading_color
              text_color
              location_name_color
              location_server_name_color
              location_link_text_color
            }
        },
        ... on PRISMIC_Products2BodyContentblock {
          type
            label
            primary {
              target_name
              background_color
              background_image
              content
              content_text_alignment
              heading
              heading_color
              image
              subheading
              subheading_color
              text_color
              wistia_id
            }
        },
        ... on PRISMIC_Products2BodyCardsv2 {
          type
            label
            fields {
              image
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              text
              text_color
              title1
              title_color
            }
            primary {
              background_color
              columns
              content_alignment
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              subheading
              subheading_color
              text_color
              background_image
            }
        },
        ... on PRISMIC_Products2BodyCtaband {
          type
            label
            primary {
              text_color
              background_color
              cta_band
              cta_primary_centered
              cta_primary_hr
              cta_primary_background_color
              cta_text_primary
              cta_text_secondary
              cta_url_primary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_url_secondary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              subheading
              background_image
            }
        },
        ... on PRISMIC_Products2BodyPromoband {
          type
label
primary {
  background_color
  cta_button_link {
    ... on PRISMIC__ExternalLink {
      _linkType
      url
    }
  }
  cta_button_text
  heading
  heading_color
  icon
  subheading
  subheading_color
}

        },
        ... on PRISMIC_Products2BodyPricingcomparison {
          type
  label
  fields {
    title1
    subtitle
    recommended
    pricing_copy
    price
    note_copy
    note
    interval
    icon_bullet
    bullet1
    bullet1_tooltip
    bullet2
    bullet2_tooltip
    bullet3
    bullet3_tooltip
    bullet4
    bullet4_tooltip
    bullet5
    bullet5_tooltip
    bullet6
    bullet6_tooltip
    bullet7
    bullet7_tooltip
    bullet8
    bullet8_tooltip
    bullet9
    bullet9_tooltip
    bullet10
    bullet10_tooltip
    bullet11
    bullet11_tooltip
    bullet12
    bullet12_tooltip
    bullet13
    bullet13_tooltip
    bullet14
    bullet14_tooltip
    bullet15
    bullet15_tooltip
    bullet16
    bullet16_tooltip
  }
  primary {
    text_color
    background_color
    background_image
    button_color
    cta_button_text
    cta_button_url {
      ... on PRISMIC__ExternalLink {
        url
        _linkType
      }
    }
    heading
    heading_color
    subheading
    subheading_color
    subnote
    target_name
  }
        },
        ... on PRISMIC_Products2BodyPricingcomparisonminimal {
          type
  label
  fields {
    title1
    recommended
    pricing_copy
    price
    interval
  }
  primary {
    text_color
    background_color
    background_image
    button_color
    cta_button_text
    cta_button_url {
      ... on PRISMIC__ExternalLink {
        url
        _linkType
      }
    }
    heading
    heading_color
    subheading
    subheading_color
    subnote
    target_name
  }
        },
        ... on PRISMIC_Products2BodyPromobandv2 {
          type
label
primary {
  background_color
  cta_button_link {
    ... on PRISMIC__ExternalLink {
      _linkType
      url
    }
  }
  cta_button_text
  heading
  heading_color
  icon
  subheading
  subheading_color
},
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Products2 = ({ data, location }) =>
  data.prismic.products2 ? (
    <MainLayout location={location} layout='products2'>
    <Helmet>
      <title>{(data.prismic.products2.title[0] && data.prismic.products2.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.products2.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.products2.path : 'https://www.digitalocean.com' + data.prismic.products2.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.products2.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.products2.title[0] ? data.prismic.products2.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.products2.description ? data.prismic.products2.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.products2.open_graph_image ? data.prismic.products2.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.products2.description ? data.prismic.products2.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.products2.title[0] ? data.prismic.products2.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.products2.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.products2.path : 'https://www.digitalocean.com' + data.prismic.products2.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.products2.open_graph_image ? data.prismic.products2.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.products2.body} />
    </MainLayout>
  ) : null;

Products2.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Products2;
